window.auguste = window.auguste || {};
window.auguste.handleButtonDisableState = ( function () {
    'use strict';

    const AFFECTED_NODE = [ 'BUTTON', 'A', 'INPUT', 'TEXTAREA', 'SELECT' ];
    const AFFECTED_NODE_SELECTOR = AFFECTED_NODE.map( tag => `${ tag.toLowerCase() }.disabled, ${ tag.toLowerCase() }[disabled]` ).join( ', ' );

    const determine_intended_state = ( mutation ) => {
        const node = mutation.target;

        if ( mutation.attributeName === 'class' ) {
            const was_disabled_via_class = ( mutation.oldValue || '' ).includes( 'disabled' );
            const is_disabled_via_class = node.classList.contains( 'disabled' );

            if ( is_disabled_via_class && !was_disabled_via_class ) {
                return 'disable';
            } else if ( !is_disabled_via_class && was_disabled_via_class ) {
                return 'enable';
            }
        } else if ( mutation.attributeName === 'disabled' ) {
            if ( node.hasAttribute( 'disabled' ) ) {
                return 'disable';
            } else {
                return 'enable';
            }
        }

        return null;
    };

    const apply_disabled_state = ( node ) => {
        if ( !node.classList.contains( 'disabled' ) ) {
            node.classList.add( 'disabled' );
        }
        if ( !node.hasAttribute( 'disabled' ) ) {
            node.setAttribute( 'disabled', '' );
        }

        if ( node.tagName === 'A' ) {
            if ( node.getAttribute( 'aria-disabled' ) !== 'true' ) {
                node.setAttribute( 'aria-disabled', 'true' );
            }
            node.setAttribute( 'role', 'link' );
            if ( node.hasAttribute( 'href' ) ) {
                node.dataset.href = node.getAttribute( 'href' );
                node.removeAttribute( 'href' );
            }
        }
    };

    const remove_disabled_state = ( node ) => {
        if ( node.classList.contains( 'disabled' ) ) {
            node.classList.remove( 'disabled' );
        }
        if ( node.hasAttribute( 'disabled' ) ) {
            node.removeAttribute( 'disabled' );
        }

        if ( node.tagName === 'A' ) {
            if ( node.hasAttribute( 'aria-disabled' ) ) {
                node.removeAttribute( 'aria-disabled' );
            }
            if ( node.dataset.href ) {
                node.setAttribute( 'href', node.dataset.href );
                delete node.dataset.href;
            }
        }
    };

    const observe_state = () => {
        const observer = new MutationObserver( ( mutationsList ) => {
            for ( const mutation of mutationsList ) {
                if ( mutation.type === 'attributes' ) {
                    const node = mutation.target;
                    if ( !( node instanceof HTMLElement ) || !AFFECTED_NODE.includes( node.tagName ) ) {
                        continue;
                    }

                    const intended_state = determine_intended_state( mutation );

                    if ( intended_state === 'disable' ) {
                        setTimeout( () => {
                            apply_disabled_state( node );
                        }, 0 );
                    } else if ( intended_state === 'enable' ) {
                        setTimeout( () => {
                            remove_disabled_state( node );
                        }, 0 );
                    }
                }
            }
        } );

        observer.observe( document.body, {
            subtree: true,
            attributes: true,
            attributeFilter: [ 'class', 'disabled' ],
            attributeOldValue: true,
        } );
    };

    const init = () => {
        document.querySelectorAll( AFFECTED_NODE_SELECTOR ).forEach( ( affected_node ) => apply_disabled_state( affected_node ) );
        observe_state();
    };

    return {
        init
    };
} )();
